import {store} from '../store'

function reverseMap (roleToFunctionalityMap) {
  let functionalityToRoleMap = new Map()
  roleToFunctionalityMap.forEach((value, key) => {
    value.forEach(valueItem => {
      if (!functionalityToRoleMap.has(valueItem)) {
        functionalityToRoleMap.set(valueItem, [])
      }
      functionalityToRoleMap.get(valueItem).push(key)
    })
  })
  return functionalityToRoleMap
}

function hasIntersect (arr1, arr2) {
  const set = new Set(arr1)
  return arr2.some(item => set.has(item))
}

/**
 * main relation map of this module
 */
const roleToFunctionalityMap = new Map([
  ['warehouseInventoryAdmin', [
    'updatePkgsInfo', 
    'adjustInventory'
  ]],
  ['warehouseOwner', [
    'updatePkgsInfo', 
    'adjustInventory',
    'warehouseAdjustBalance',
    'financialReport' 
  ]],
  ['warehouseReport', [
  ]],
  ['warehouseBillingAdmin', [
    'financialReport'
  ]],
  ['warehouseOrgAdmin', [
    'warehouseAdjustBalance'
  ]],
  ['sysAdmin', [
    'registrationAdvance',
    'sysfinancialReport'
  ]],
  ['sysAdminReport', [
    'sysfinancialReport'
  ]],
  ['sysAdminFinance', [
    'sysBillingOfflineDeposit',
    'sysBillingAdjustBalance'
  ]],
  // ['warehouseDownload', [
  //   'warehouseDownload' 
  // ]],
  ['warehousePricing', [
    'Pricing' 
  ]],
  ['warehousePackageOperator', [
    'warehousePackageOperator' 
  ]],
  ['warehouseFinance', [
    'warehouseFinance' 
  ]]
])

const functionalityToDisplayNameMap = new Map([
  ['updatePkgsInfo', '[Update packages info]'],
  ['adjustInventory', '[Adjust inventory]'],
  ['warehouseAdjustBalance', '[Warehouse adjust balance]'],
  ['financialReport', 'Financial report'],
  ['registrationAdvance', 'Add reqistration code'],
  ['sysfinancialReport', 'System financial report'],
  ['sysBillingOfflineDeposit', 'System billing offline deposit'],
  ['sysBillingAdjustBalance', 'System billing adjust balance'],
  ['Pricing', '[Pricing Plan]']
])

const roleToFunctionalityDisplayNameMap = new Map()
roleToFunctionalityMap.forEach((value, key) => {
  value.forEach(item => {
    if (!roleToFunctionalityDisplayNameMap.has(key)) {
      roleToFunctionalityDisplayNameMap.set(key, [])
    }
    roleToFunctionalityDisplayNameMap.get(key).push(functionalityToDisplayNameMap.get(item))
  })
})

const functionalityToRoleMap = reverseMap(roleToFunctionalityMap)
const authMixin = {
  methods: {
    hasAuthToFunctionality (functionality) {
      const requiredRoles = functionalityToRoleMap.get(functionality)
      const userRoles = store.getters.user?.roles || []
      return hasIntersect(requiredRoles, userRoles)
    }
  }
}
export {
  roleToFunctionalityDisplayNameMap,
  authMixin
}



// WEBPACK FOOTER //
// ./src/router/functionalityAuth.js